import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import SwipeableViews from "react-swipeable-views";
import {
  Grid,
  Button,
  SvgIcon,
  MobileStepper,
} from "@mui/material";
import { CourseButton } from "../../atom";
import _ from "lodash";
import moment from "moment-timezone";
import { IMAGES } from "../../../assets/Images";
import { renderTruncatedText } from "../../../core/Constant";

const LiveClassCard = ({ list = [], onButtonClick = () => { } }) => {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = list?.length;
  const visibleSteps = Math.min(maxSteps, 5);
  const indicatorStart = Math.min(
    Math.max(activeStep - visibleSteps + 1, 0),
    maxSteps - visibleSteps
  );
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const onViewWebinar = (item) => {
    try {
      window.webkit.messageHandlers.openURL.postMessage(item);
    } catch {
      window.open(item);
    }
  };

  const formatDate = (date) =>
    _.isNull(date) || !date ? "" : moment(date).format("DD-MMM-YYYY");

  const formatTime = (time) =>
    time ? moment(time, "HH:mm:ss").format("hh:mm A") : "";

  const convertToUserTime = (date, time, timeExt, apiTimezone) => {
  if (!date || !time) return { date: formatDate(date), time: "", timezone: "" };   
  try {
    const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    
    const fullTimeStr = timeExt ? `${time} ${timeExt}` : time;
    const parseFormat = timeExt ? "YYYY-MM-DD hh:mm:ss A" : "YYYY-MM-DD HH:mm:ss";

    const sourceMoment = apiTimezone
        ? moment.tz(`${date} ${fullTimeStr}`,
      parseFormat,
      apiTimezone
        )
        : moment(`${date} ${fullTimeStr}`, parseFormat);

    const localMoment = sourceMoment.clone().tz(userTz);

    return {
      date: localMoment.format("DD-MMM-YYYY"),
      time: localMoment.format("hh:mm A"),
      timezone: localMoment.format("z"),
    };
  } catch (error) {
      return { date: formatDate(date), time: formatTime(time), timezone: apiTimezone || "" };
    }
  };

  return (
    <Grid
      container
      flexDirection={"column"}
      alignItems={"center"}
      rowGap={0}
      sx={{
        width: "100%",
        minWidth: 0,
        minHeight: { xs: 420, sm: 460 },
        height: "100%",
        boxSizing: "border-box",
        p: { xs: 1, sm: 2 },
      }}
      flexWrap={"nowrap"}
      justifyContent={"center"}
    >
      {/* Header */}
      <Grid item sx={{ mb: 1 }}>
        <h3 style={{ fontWeight: 700, marginTop: 8, marginBottom: 4, color: "#9834F0" }}>Live Webinar</h3>
      </Grid>
      {list?.length === 0 ? (
        <Grid item sx={{ display: "flex", alignItems: "center", justifyContent: "center", flex: 1 }}>
          <img
            src={IMAGES.noVideo}
            alt="video"
            style={{
              objectFit: "cover",
              width: 180
            }}
          />
        </Grid>
      ) : (
        <Grid item sx={{ width: '100%' }}>
          <SwipeableViews
            axis={"x"}
            index={activeStep}
            onChangeIndex={handleStepChange}
            enableMouseEvents
            style={{
              backgroundColor: "#ffffff",
              width: "100%",
              minWidth: 0,
              overflow: "hidden",
            }}
          >
            {list.map((item, index) => {
              const date = _.get(item, "date", null);
              const time = _.get(item, "time", null);
              const timeExt = _.get(item, "time_ext", "");
              const apiTimezone = _.get(item, "timezone", null);
              const title = _.get(item, "name", "");
              const courseName = _.get(item, "course_name", "");
              const duration = _.get(item, "duration", "");
              const note = _.get(item, "note", null);

              const webinarStart = moment(item.webinar_datetime);
              const webinarEnd = moment(item.end_datetime);
              const now = moment();
              const isLive = now.isBetween(webinarStart, webinarEnd);

              const { date: localDate, time: localTime, timezone: localTz } =
                convertToUserTime(date, time, timeExt, apiTimezone);

              return (
                <Grid
                  key={index}
                  container
                  flexDirection={"column"}
                  alignItems={"center"}
                  sx={{ gap: { xs: 1, sm: "6px" }, width: "100%", minWidth: 0, px: { xs: 0.5, sm: 1 } }}
                >
                  {/* Course Name */}
                  <Grid xs={12} item sx={{ width: "100%" }}>
                    <p style={{
                      textAlign: "center",
                      fontSize: "13px",
                      fontWeight: 600,
                      margin: "0",
                      color: "#2D3945",
                      maxWidth: "100%",
                      overflowWrap: "anywhere",
                    }}>
                      {renderTruncatedText(courseName, { limit: 30 })}                    </p>
                  </Grid>

                  {/* Webinar Title */}
                  {title ? (
                    <Grid xs={12} item sx={{ width: "100%" }}>
                      <p style={{
                        textAlign: "center",
                        maxWidth: "100%",
                        overflowWrap: "anywhere",
                        color: "#9834F0",
                        fontWeight: 700,
                        fontSize: "13px",
                        margin: "0",
                      }}>
                        {title}
                      </p>
                    </Grid>
                  ) : null}

                  {/* Note */}
                  {note ? (
                    <Grid xs={12} item sx={{ width: "100%", px: 2 }}>
                      <p style={{
                      textAlign: "center",
                      fontSize: "13px",
                      fontWeight: 600,
                      margin: "0",
                      color: "#2D3945",
                      maxWidth: "100%",
                      overflowWrap: "anywhere",
                    }}
                      >
                        {note}
                      </p>
                    </Grid>
                  ) : null}

                  {/* Date */}
                  <Grid xs={12} item sx={{ width: "100%" }}>
                    <p style={{ textAlign: "center", fontSize: "10px", margin: "0" }}
                      className="dashboard-student-subtext">
                      Date: {localDate}
                    </p>
                  </Grid>

                  {/* Time in user's local timezone */}
                  {localTime ? (
                    <Grid xs={12} item sx={{ width: "100%" }}>
                      <p style={{ textAlign: "center", fontSize: "8px", margin: "0" }}
                        className="dashboard-student-subtext">
                        Time: {localTime} {localTz ? `(${localTz})` : ""}
                      </p>
                    </Grid>
                  ) : null}

                  {/* Duration */}
                  <Grid xs={12} item sx={{ width: "100%" }}>
                    <p style={{ textAlign: "center", fontSize: "8px", margin: "0" }}
                      className="dashboard-student-subtext">
                      {duration} minutes
                    </p>
                  </Grid>

                  {/* LIVE badge */}
                  <Grid xs={12} item sx={{ width: "100%", display: "flex", justifyContent: "center", mt: 0.5 }}>
                    {isLive ? <LiveIcon /> : <UpcomingIcon />}
                  </Grid>

                  {/* View Class Button */}
                  <Grid item xs={12} sx={{ width: "100%"}}>
                    <CourseButton
                      onButtonClick={() => {
                        onViewWebinar(item.join_url);
                      }}
                      color={"#9834F0"}
                      text={"View Class"}
                    />
                  </Grid>

                </Grid>
                        );
                      })}
                  </SwipeableViews>
                    <MobileStepper
                      steps={visibleSteps}
                      position="static"
                      activeStep={activeStep - indicatorStart}
                      sx={{ padding: "4px 0" }}
                      nextButton={
                        <Button
                          size="small"
                          onClick={handleNext}
                          disabled={activeStep === maxSteps - 1}
                          sx={{
                            "&:hover": {
                              backgroundColor: "#ffffff !important",
                              color: "#28b882 !important"
                            },
                          }}
                        >
                          {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                        </Button>
                      }
                      backButton={
                        <Button
                          size="small"
                          onClick={handleBack}
                          disabled={activeStep === 0}
                          sx={{
                            "&:hover": {
                              backgroundColor: "#ffffff !important",
                              color: "#28b882 !important"
                            },
                          }}
                        >
                          {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                        </Button>
                      }
                    />
        </Grid>
      )}
    </Grid>
  );
};

export default LiveClassCard;

const LiveIcon = () => {
  return (
    <SvgIcon sx={{ width: "70px", maxwidth: "150px", height: "100%" }}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 72 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="72" height="31" rx="15.5" fill="#E2535D" />
        <path
          d="M20.245 21V10.5H22.675V19.02H27.94V21H20.245ZM29.2977 21V10.5H31.7277V21H29.2977ZM41.841 10.5H44.256L39.711 21H37.311L32.781 10.5H35.406L38.601 18L41.841 10.5ZM47.5477 19.05H53.2627V21H45.1327V10.5H53.0677V12.45H47.5477V14.73H52.4227V16.62H47.5477V19.05Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
};

const UpcomingIcon = () => {
  return (
    <SvgIcon sx={{ width: "110px", maxWidth: "150px", height: "100%" }}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 110 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="110" height="30" rx="15.5" fill="#9834F0" />
        <text
          x="55"
          y="16"
          fill="white"
          fontSize="12"
          fontWeight="bold"
          textAnchor="middle"
          dominantBaseline="central"
          fontFamily="Montserrat"
        >
          UPCOMING
        </text>
      </svg>
    </SvgIcon>
  );
};